/**
 * Created by mykurisu on 2018/4/17.
 */
const defaults = {
    toastShow: false,
    toastMain: '',
    toastSub: ''
};


export default (state = defaults, action) => {
    switch (action.type) {
        case 'TOASTSHOW':
            return {...state, toastShow: true, toastMain: action.payload.toastMain, toastSub: action.payload.toastSub};
        case 'TOASTHIDE':
            return {...state, toastShow: false};
        default:
            return state;
    }
}





// WEBPACK FOOTER //
// ./src/reducers/global_component.js